export const MESSAGE_GETTER_DICTIONARY = {
  UPDATE_TABLE_SETTINGS_SUCCESS: () => "Your table settings have been saved.",
  UPDATE_TABLE_SETTINGS_FAILURE: () =>
    "There was an error saving your table settings."
};
